function removeEmptyJudgeMe() {
  document.querySelectorAll('.jdgm-widget').forEach(widget => {

    const badge = widget.querySelector('.jdgm-prev-badge');
    if (!badge) return;

    const reviewCount = badge.dataset.numberOfReviews;
    const rating = badge.dataset.averageRating;

    if (reviewCount === "0" || rating === "0.00") {
      widget.remove();
    }

  });
}



document.addEventListener("click", function (e) {

  if (e.target.closest(".m-collapsible--button")) {

    const btn = e.target.closest(".m-collapsible--button");
    
    if (btn.innerText.includes("Umsagnir")) {

      setTimeout(() => {
        const reviewSection = document.querySelector("#judgeme_product_reviews");

        if (reviewSection) {
          reviewSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }

      }, 300);
    }
  }

});



function wrapAlsoBought() {
  const headings = document.querySelectorAll(
    ".m-product-recommendations .m-section__heading"
  );

  headings.forEach(heading => {
    if (
      heading.textContent.includes("Also Bought") &&
      !heading.querySelector("span")
    ) {
      heading.innerHTML = heading.innerHTML.replace(
        "Also Bought",
        "<span>Also Bought</span>"
      );
    }
  });
}

/* Run initially */
document.addEventListener("DOMContentLoaded", wrapAlsoBought);

/* Watch for dynamic load */
const observer = new MutationObserver(wrapAlsoBought);
observer.observe(document.body, { childList: true, subtree: true });


document.addEventListener("DOMContentLoaded", function () {
  const title = document.querySelector(".m-product-title");

  if (title) {
    const text = title.textContent;

    if (text.includes("-")) {
      const parts = text.split("-");

      title.innerHTML = `
        ${parts[0].trim()} 
       - <span class="title-highlight"> ${parts.slice(1).join("-").trim()}</span>
      `;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach(item => {
    item.addEventListener("toggle", function () {

      if (item.open) {
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.removeAttribute("open");
          }
        });
      }

    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const rows = document.querySelectorAll("section#loftthurrkun-samanburdur tbody tr");

  rows.forEach(row => {
    const cols = row.querySelectorAll("td");

    [1, 2].forEach(index => {
      const td = cols[index];
      if (!td) return;

      const span = td.querySelector("span");
      if (!span) return;

      let text = span.textContent.trim();

      // Match percentage
      const percentMatch = text.match(/\d+\s*–\s*\d+%/);

      if (percentMatch) {
        // --- If percentage exists ---
        const percent = percentMatch[0];
        let remainingText = text.replace(percent, "").trim();

        span.textContent = percent;
        td.innerHTML = span.outerHTML + (remainingText ? " " + remainingText : "");

      } else {
        // --- If NO percentage → remove span completely ---
        td.textContent = text;
      }
    });

    // Fix duplicate Minerals → Digestibility
    if (
      cols[0] &&
      cols[0].textContent.trim() === "Minerals" &&
      row.textContent.toLowerCase().includes("digest")
    ) {
      cols[0].innerHTML = "<b>Digestibility</b>";
    }
  });
});
